<template>
  <div class="dd-video-list__wrap">
    <div class="dd-video-list" ref="list">
      <VideoListItem :data="item" v-for="(item, i) in data" :key="i">
    </VideoListItem>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const bounding = this.$refs.list.getBoundingClientRect() 
      const distance = 100
      
      if (bounding.bottom + distance < window.innerHeight) {
        this.$emit('reachBottom')
      }
    }
  }
}
</script>

<style lang="scss">
.dd-video-list {
  margin-left: -115px;
  text-align: center;

  &__wrap {
    @extend %wrap;
    @extend %clearfix;
  }

  .dd-video-item {
    margin-left: 115px;
    margin-top: 90px;
  }

  @include media-tablet {
    margin-left: 0;
    padding: 0 70px;

    .dd-video-item  {
      margin-top: 48px;
      margin-left: auto !important;
      margin-right: auto;
    }
  }
}
</style>
